import { SENDERS_LIST_LOADING, SENDERS_LIST_SUCCESS, SENDERS_LIST_FAILED,
    CLEAR_SENDERS_LIST_STATUS } from '../actions/verify.action';

import { SendersList, ISender } from '../models/senders.interface';

const initialState: SendersList = {
    loading: true,
    error: false,
    message: "",
    data: [],
    total: 0
}

const sendersListReducer = (state: SendersList = initialState, action: any) : SendersList => {
    switch (action.type) {
        case SENDERS_LIST_LOADING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case SENDERS_LIST_SUCCESS:
            const newData = action.payload.res.map((item: ISender)=>{
                return {id: item.id, sender: item.sender}
            });
            return {
                ...state,
                loading: false,
                error: false,
                message: "",
                data: newData
            }
        case SENDERS_LIST_FAILED:
            return {
                ...state,
                loading: false,
                error: true,
                message: action.payload.error.message || ""
            }
        case CLEAR_SENDERS_LIST_STATUS:
            return {
                ...state,
                error: false,
                message: ""
            }
        default:
            return state;
    }
}

export default sendersListReducer;